// Copyright (c) Meta Platforms, Inc. and affiliates.

'use client';

/**
 * @file ListContext.tsx
 * @input Uses React createContext
 * @output Exports ListContext for sharing density between List and ListItem
 * @position Internal context; consumed by List.tsx and ListItem.tsx
 */
import { createContext } from 'react';
export const ListContext = /*#__PURE__*/createContext(null);
ListContext.displayName = 'ListContext';